module.exports = __webpack_public_path__ + "img/FlankerSun.99f56b8a.png";